<template>
<div>

  <v-menu
    offset-y bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="button-with-icon mainColor--text text-none"
        rounded small outlined color="mainColor"
        :disabled="$store.getters.isDemoUser"
        v-bind="attrs" v-on="on"
      >
        <span class="">{{ $store.getters.whiteGloveFamilyProgramName }} top up</span>
      </v-btn>
    </template>

    <v-card class="p-4" style="width: 280px;">

      <div class="mb-3 mainColor--text" style="font-weight: 700; font-size: 1rem; line-height: 1.5;">
        Top up your {{ $store.getters.whiteGloveFamilyProgramName }} balance
      </div>
      <div class="mb-3 mainColor--text" style="line-height: 1.5;">
        Add funds to your {{ $store.getters.whiteGloveFamilyProgramName }} balance and use them to order premium content services from your POP team.
      </div>
      <div class="mb-1 d-flex align-center gap5">
        <img src="/static/icon_crown_green.svg" /><span class="mainColor--text" style="font-weight: 700;">{{ $store.getters.whiteGloveFamilyProgramName }} Program</span>
      </div>
      <div class="mb-5 mainColor--text">
        Current balance: <b>{{ formatCurrency(ownerUser.balance_cents / 100) }}</b>
      </div>

      <v-btn
        block color="profileAnchorColor"
        class="button-with-icon whiteColor--text text-none"
        :disabled="$store.getters.isDemoUser"
        @click="$store.commit('setShowBalanceTopUpModal', true)"
      >
        <span>Top up</span>
      </v-btn>

    </v-card>

  </v-menu>

  <balance-top-up-modal v-if="$store.state.showBalanceTopUpModal" />

</div>
</template>

<script>
import { formatCurrency } from '@/utils'
import BalanceTopUpModal from './BalanceTopUpModal.vue';

export default {
  props: [],
  components: {
    BalanceTopUpModal
  },
  data() {
    return {
      
    };
  },
  computed: {
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user
    },
  },
  methods: {
    formatCurrency: formatCurrency,
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>

</style>
